import FocusLock from 'react-focus-lock';

import type { FocusTargetProps } from './FocusTarget.d';

const FocusTarget = ({ children, ...props }: FocusTargetProps) => (
  <FocusLock {...props}>{children}</FocusLock>
);

export default FocusTarget;
